export interface TraySubmissionResult {
  trayId: string
  barcode: string
  description: string
  success: boolean
  error?: string
  createdTrayId?: number
  attempts: number
}

export interface TraySubmissionSummary {
  successful: TraySubmissionResult[]
  failed: TraySubmissionResult[]
  totalTrays: number
  successCount: number
  failureCount: number
}

export interface TrayVerificationResult {
  barcode: string
  exists: boolean
  error?: string
  trayData?: any
}

export interface TraySubmissionConfig {
  maxRetries: number
  retryDelay: number
  verificationDelay: number
}

export const DEFAULT_SUBMISSION_CONFIG: TraySubmissionConfig = {
  maxRetries: 3,
  retryDelay: 1000, // 1 second
  verificationDelay: 2000, // 2 seconds
}
